// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./colors.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/MaisonNeue/MaisonNeueWEB-Light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/MaisonNeue/MaisonNeueWEB-LightItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/MaisonNeue/MaisonNeueWEB-Book.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/MaisonNeue/MaisonNeueWEB-BookItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/MaisonNeue/MaisonNeueWEB-Medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/MaisonNeue/MaisonNeueWEB-MediumItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/MaisonNeue/MaisonNeueWEB-Demi.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./fonts/MaisonNeue/MaisonNeueWEB-DemiItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./fonts/MaisonNeue/MaisonNeueWEB-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./fonts/MaisonNeue/MaisonNeueWEB-BoldItalic.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./fonts/MaisonNeue/MaisonNeueWEB-Mono.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./fonts/MaisonNeue/MaisonNeueWEB-MonoItalic.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]};
    font-family: MaisonNeue, sans-serif;
    font-size: 14px;
    font-style: normal;
    font-weight: normal;
  }

h1 {
    font-family: MaisonNeue, sans-serif;
    font-size: 30px;
    margin: 0;
  }

@media only screen and (max-width: 768px) {

h1 {
      font-size: 26px;
      letter-spacing: normal;
      margin-bottom: 10px;
  }
    }

h2 {
    font-family: MaisonNeue, sans-serif;
    font-size: 24px;
    margin: 0;
  }

h3 {
    font-family: MaisonNeue, sans-serif;
    font-size: 20px;
    font-weight: 400;
    margin: 0 0 20px;
  }

h4 {
    font-family: MaisonNeue, sans-serif;
    font-size: 16px;
    font-weight: 700;
    margin: 0 0 20px;
  }

h5, h6 {
    font-family: MaisonNeue, sans-serif;
    font-size: 16px;
    font-weight: 600;
    margin: 0;
  }

h1:last-child, h2:last-child, h3:last-child, h4:last-child, h5:last-child, h6:last-child {
      margin-bottom: 0;
    }

@font-face {
  font-family: MaisonNeue;
  font-style: normal;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format('woff');
}

@font-face {
  font-family: MaisonNeue;
  font-style: italic;
  font-weight: 300;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('woff');
}

@font-face {
  font-family: MaisonNeue;
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff');
}

@font-face {
  font-family: MaisonNeue;
  font-style: italic;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
}

@font-face {
  font-family: MaisonNeue;
  font-style: normal;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('woff');
}

@font-face {
  font-family: MaisonNeue;
  font-style: italic;
  font-weight: 500;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('woff');
}

@font-face {
  font-family: MaisonNeue;
  font-style: normal;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff');
}

@font-face {
  font-family: MaisonNeue;
  font-style: italic;
  font-weight: 600;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
}

@font-face {
  font-family: MaisonNeue;
  font-style: normal;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format('woff');
}

@font-face {
  font-family: MaisonNeue;
  font-style: italic;
  font-weight: 700;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format('woff');
}

@font-face {
  font-family: MaisonMono;
  font-style: normal;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format('woff');
}

@font-face {
  font-family: MaisonMono;
  font-style: italic;
  font-weight: 400;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format('woff');
}
`, "",{"version":3,"sources":["webpack://./universal/styles/type.css"],"names":[],"mappings":"AAIE;IACE,mDAAW;IACX,mCAAmC;IACnC,eAAe;IACf,kBAAkB;IAClB,mBAAmB;EACrB;;AAEA;IACE,mCAAmC;IACnC,eAAe;IACf,SAAS;EAOX;;AALE;;AALF;MAMI,eAAe;MACf,sBAAsB;MACtB,mBAAmB;EAEvB;IADE;;AAGF;IACE,mCAAmC;IACnC,eAAe;IACf,SAAS;EACX;;AAEA;IACE,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;AAEA;IACE,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;AAEA;IAEE,mCAAmC;IACnC,eAAe;IACf,gBAAgB;IAChB,SAAS;EACX;;AAQE;MACE,gBAAgB;IAClB;;AAIJ;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,2DAAsE;AACxE;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,2DAA4E;AAC9E;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,2DAAqE;AACvE;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,2DAA2E;AAC7E;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,2DAAuE;AACzE;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,2DAA6E;AAC/E;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,2DAAqE;AACvE;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,2DAA2E;AAC7E;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,2DAAqE;AACvE;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,2DAA2E;AAC7E;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,4DAAqE;AACvE;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,4DAA2E;AAC7E","sourcesContent":["@value colors: \"styles/colors.css\";\n@value text, textLight, gtBlueDark from colors;\n\n:global {\n  html {\n    color: text;\n    font-family: MaisonNeue, sans-serif;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: normal;\n  }\n\n  h1 {\n    font-family: MaisonNeue, sans-serif;\n    font-size: 30px;\n    margin: 0;\n\n    @media only screen and (max-width: 768px) {\n      font-size: 26px;\n      letter-spacing: normal;\n      margin-bottom: 10px;\n    }\n  }\n\n  h2 {\n    font-family: MaisonNeue, sans-serif;\n    font-size: 24px;\n    margin: 0;\n  }\n\n  h3 {\n    font-family: MaisonNeue, sans-serif;\n    font-size: 20px;\n    font-weight: 400;\n    margin: 0 0 20px;\n  }\n\n  h4 {\n    font-family: MaisonNeue, sans-serif;\n    font-size: 16px;\n    font-weight: 700;\n    margin: 0 0 20px;\n  }\n\n  h5,\n  h6 {\n    font-family: MaisonNeue, sans-serif;\n    font-size: 16px;\n    font-weight: 600;\n    margin: 0;\n  }\n\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n}\n\n@font-face {\n  font-family: MaisonNeue;\n  font-style: normal;\n  font-weight: 300;\n  src: url('./fonts/MaisonNeue/MaisonNeueWEB-Light.woff') format('woff');\n}\n\n@font-face {\n  font-family: MaisonNeue;\n  font-style: italic;\n  font-weight: 300;\n  src: url('./fonts/MaisonNeue/MaisonNeueWEB-LightItalic.woff') format('woff');\n}\n\n@font-face {\n  font-family: MaisonNeue;\n  font-style: normal;\n  font-weight: 400;\n  src: url('./fonts/MaisonNeue/MaisonNeueWEB-Book.woff') format('woff');\n}\n\n@font-face {\n  font-family: MaisonNeue;\n  font-style: italic;\n  font-weight: 400;\n  src: url('./fonts/MaisonNeue/MaisonNeueWEB-BookItalic.woff') format('woff');\n}\n\n@font-face {\n  font-family: MaisonNeue;\n  font-style: normal;\n  font-weight: 500;\n  src: url('./fonts/MaisonNeue/MaisonNeueWEB-Medium.woff') format('woff');\n}\n\n@font-face {\n  font-family: MaisonNeue;\n  font-style: italic;\n  font-weight: 500;\n  src: url('./fonts/MaisonNeue/MaisonNeueWEB-MediumItalic.woff') format('woff');\n}\n\n@font-face {\n  font-family: MaisonNeue;\n  font-style: normal;\n  font-weight: 600;\n  src: url('./fonts/MaisonNeue/MaisonNeueWEB-Demi.woff') format('woff');\n}\n\n@font-face {\n  font-family: MaisonNeue;\n  font-style: italic;\n  font-weight: 600;\n  src: url('./fonts/MaisonNeue/MaisonNeueWEB-DemiItalic.woff') format('woff');\n}\n\n@font-face {\n  font-family: MaisonNeue;\n  font-style: normal;\n  font-weight: 700;\n  src: url('./fonts/MaisonNeue/MaisonNeueWEB-Bold.woff') format('woff');\n}\n\n@font-face {\n  font-family: MaisonNeue;\n  font-style: italic;\n  font-weight: 700;\n  src: url('./fonts/MaisonNeue/MaisonNeueWEB-BoldItalic.woff') format('woff');\n}\n\n@font-face {\n  font-family: MaisonMono;\n  font-style: normal;\n  font-weight: 400;\n  src: url('./fonts/MaisonNeue/MaisonNeueWEB-Mono.woff') format('woff');\n}\n\n@font-face {\n  font-family: MaisonMono;\n  font-style: italic;\n  font-weight: 400;\n  src: url('./fonts/MaisonNeue/MaisonNeueWEB-MonoItalic.woff') format('woff');\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `"styles/colors.css"`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`
};
export default ___CSS_LOADER_EXPORT___;
